import { Clock } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';

export function RecentActivity({ checkins }) {
  const activityItems = Array.isArray(checkins) ? checkins : [];

  return (
    <div 
      className="bg-zinc-900/50 border border-white/10 rounded-sm p-6"
      data-testid="recent-activity"
    >
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-white tracking-tight">Recent Activity</h3>
          <p className="text-xs text-zinc-500 mt-1">Latest gym check-ins</p>
        </div>
        <div className="w-10 h-10 bg-[#D4AF37]/10 rounded-sm flex items-center justify-center">
          <Clock className="w-5 h-5 text-[#D4AF37]" strokeWidth={1.5} />
        </div>
      </div>
      
      <div className="max-h-[320px] space-y-3 overflow-y-auto pr-1">
        {activityItems.length > 0 ? (
          activityItems.map((checkin, index) => (
            <div 
              key={checkin.id || index}
              className="flex items-center gap-3 p-3 bg-zinc-900/50 rounded-sm border border-white/5 hover:border-white/10 transition-colors"
              data-testid={`activity-item-${index}`}
            >
              <img
                src={checkin.member_avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(checkin.member_name)}&background=18181B&color=D4AF37`}
                alt={checkin.member_name}
                className="w-9 h-9 rounded-sm object-cover border border-white/10"
              />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-white truncate">{checkin.member_name}</p>
                <p className="text-xs text-zinc-500">Checked in</p>
              </div>
              <span className="text-xs text-zinc-500 whitespace-nowrap">
                {formatDistanceToNow(new Date(checkin.checked_in_at), { addSuffix: true })}
              </span>
            </div>
          ))
        ) : (
          <div className="text-center py-8 text-zinc-500 text-sm">
            No recent activity
          </div>
        )}
      </div>
    </div>
  );
}

